import ContactForm from "../landing/ContactForm";
import StudyNavbar from "./StudyNav";
import Footer from "./StudyFooter";
const StudyLayout = ({ children }) => {
    return (
        <div className="min-h-screen flex flex-col bg-[#fafafa]">
            <StudyNavbar />
            <main className="flex-1">{children}</main>
            <ContactForm />
            <Footer />
        </div>
    );
};

export default StudyLayout;
